import React from "react";
import { IconProps } from "../icon";

export const FlipBackwardIcon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M3 9h13.5a4.5 4.5 0 110 9H12M3 9l4-4M3 9l4 4"
    />
  </svg>
);
